import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from '../services/user.service';
import { Store } from '@ngrx/store';
import { userActions } from './user.actions';
import { ToastService } from '../../shared/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Injectable()
export class UserEffects {
  private router = inject(Router);

  constructor(private actions$: Actions,
        private userService: UserService,
        private store: Store,
        private toastService: ToastService,
        private translate: TranslateService) {}

  login$ = createEffect(() => this.actions$.pipe(
      ofType(userActions.login),
      switchMap((action) =>
        this.userService.login(action.user).pipe(
          map(user => userActions.loginSuccess({user})),
          catchError(() => of(userActions.loginFailure({ error: 'Invalid credentials' })))
        )
      )
  ));

  logout$ = createEffect(() => this.actions$.pipe(
    ofType(userActions.logout),
    map((action) => {
      this.userService.logout();
      return userActions.logoutSuccess();
    })
  ));


  retryLogin$ = createEffect(() => this.actions$.pipe(
    ofType(userActions.retryLogin),
    switchMap(() =>
      this.userService.retryLogin().pipe(
        map(user => {
          if (user.timeout === undefined || user.timeout < 0) {
            this.router.navigate(['/user/timeout']);
            return userActions.logout();
          }
          return userActions.loginSuccess({user});
        }),
        catchError(() => of(userActions.retryLoginFailure({ error: 'Retry login failed' })))
      )
    )
  ));

loginsso$ = createEffect(() => this.actions$.pipe(
      ofType(userActions.loginWithSso),
      switchMap((action) =>
        this.userService.loginWithSso(action.token).pipe(
          map(user => userActions.loginSuccess({user})),
          catchError(() => of(userActions.loginFailure({ error: 'Invalid credentials' })))
        )
      )
  ));
}
